import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { EstateRagDocumentSourceTypeKey } from '@/modules/ai/constants/EstateRagDocumentSourceTypeKey';
import { EstateRagDocumentSourceType } from '@/modules/ai/constants/EstateRagDocumentSourceType';

export class EstateRagDocumentObject extends BaseEntityModel {
  id?: number;
  ragDocumentId?: string;
  source?: EstateRagDocumentSourceTypeKey;
  country?: string;
  jurisdiction?: string[];
  county?: string;
  estateType?: string;
  type?: string;
  subType?: string;
  title?: string;
  url?: string;

  constructor(model: Partial<EstateRagDocumentObject> = {}) {
    super(model);

    this.id = model.id;
    this.ragDocumentId = model.ragDocumentId;
    this.source = model.source;
    this.country = model.country;
    this.jurisdiction = model.jurisdiction;
    this.county = model.county;
    this.estateType = model.estateType;
    this.type = model.type;
    this.subType = model.subType;
    this.title = model.title;
    this.url = model.url;
  }

  get sourceEnum(): EstateRagDocumentSourceType | undefined {
    return this.source ? EstateRagDocumentSourceType.getByKey(this.source) : undefined;
  }

  get isNotion(): boolean {
    return this.source === EstateRagDocumentSourceTypeKey.NOTION;
  }

  get isLegalReasoning(): boolean {
    return this.source === EstateRagDocumentSourceTypeKey.LEGAL_REASONING;
  }

  get isContentLibrary(): boolean {
    return this.source === EstateRagDocumentSourceTypeKey.CONTENT_LIBRARY;
  }

  get isEstateLaw(): boolean {
    return this.source === EstateRagDocumentSourceTypeKey.ESTATE_LAW;
  }
}
